export default __webpack_public_path__ + "static/media/newLogoSlogan.e65677c9.png";